import { HealthCheckType, HealthStatus } from './healthcheck';

export interface BaseResponse<T> {
  appId: string;
  status: T;
}

export enum GenesisMicroAppAction {
  READY = 'PONG',
  CLOSE_WITH_ACTION = 'CloseWithAction',
  CLOSE_NO_ACTION = 'CloseNoAction',
  MINIMIZE_NO_ACTION = 'MinimizeNoAction',
  STARTED_WITH_ACTION_IMPORT = 'ImportWithAction',
  STARTED_WITH_ACTION_EXPORT = 'ExportWithAction',
  MINIMIZE_WITH_ACTION = 'MinimizeWithAction',
  REOPEN_ERROR = 'ReOpenOnError'
}

export enum MicroAppStatus {
  DONE = 'DONE',
  STARTED = 'STARTED',
  NOT_STARTED = 'NOT_STARTED',
  ERROR = 'ERROR'
}

export interface MicroAppTaskStatus {
  status: MicroAppStatus;
  taskId: string;
}

export interface GenesisMicroAppResponse extends BaseResponse<MicroAppTaskStatus> {
  appID: string;
  type: GenesisMicroAppAction;
  sessionID: string;
  timeStamp: Date;
  context?: {
    taskID: string;
    lraStatusURL?: string;
  };
}

export interface WindowStats {
  isClosed: boolean;
}
export interface HealthStats {
  isHealthy: boolean;
  status: HealthStatus;
  lastSessionActive: Date;
  noResponseAttempts?: number;
}
export interface PerfStats {
  lastMessageSentOn: number;
  lastMessageReceivedOn: number;
}
export interface Stats {
  window: WindowStats;
  performance: PerfStats;
  health: HealthStats;
}

export interface PostMessengerInfo {
  targetAppId: string;
  targetAppWindow?: Window;
  targetOrigin?: string;
  healthCheckInterval?: number;
  healthCheckMaxRetry?: number;
  onResponse?: (data: any) => void;
  onWindowUpdates?: (stats: WindowStats) => void;
  healthCheckType?: HealthCheckType;
  onHealthUpdates?: (stats: HealthStats) => void;
  onPerfUpdates?: (stats: PerfStats) => void;
}

export interface PostMessengerRegistryInfo extends PostMessengerInfo {
  stats?: Stats;
  lastStatTracker?: Stats;
  closeTimer?: any;
  closeInterval?: any;
}

export enum RisRequestType {
  INIT_USER_CONTEXT = 'initUserContext',
  OPEN = 'openProcedure',
  CLEAR = 'clearContext',
  CLOSE = 'closeRIS',
  UPDATE_TOKEN = 'keepAlive'
}

export type RisSupportedTab = 'scanneddocuments' | 'accountinginfo';

export interface RisResponse {
  appId: string;
  code: number;
  description: string;
  requestId: string;
  errorCode?: string;
}

interface RisRequestBase {
  requestType: RisRequestType;
  requestId: string;
  token: string;
}

interface RisPatientData {
  patientId: string;
  patientName: string;
  patientDOB: string;
}
export interface RisInitUser extends RisRequestBase {
  callingEntity: string;
}
export interface RisOpenProcedure extends RisRequestBase {
  accessionId: string;
  patientData?: RisPatientData;
  tabsToShow?: RisSupportedTab[];
  activeTab?: RisSupportedTab;
}

export type RisRequest = RisRequestBase | RisInitUser | RisOpenProcedure;
